import { AnalysisRun, AnalysisRunService } from "../services/analysis-run.service";
import { IAnalyzer } from "../interfaces/analyzer";
import { AnalysisResult } from "../models/analysis-result";
import { ConfigService } from "../services/config.service";
import { RiskLevel } from "../models/risk-level";
import { IAnalyzerConfig } from "../interfaces/analyzer-config";
import { MessageService } from "../services/message.service";
import { MailUtils } from "../utils/mail.utils";
import { LogService } from "../services/log.service";
import { Inject, Injector } from "@angular/core";
import { StringUtils } from "../utils/string.utils";
import { ANALYZERS, HEADERS } from "../models/constants";
import { TranslateService } from "@ngx-translate/core";

export class ReplyToAnalyzer implements IAnalyzer {
    private readonly run: AnalysisRun;

    private configService: ConfigService
    private log: LogService
    private messageService: MessageService
    private replyTo: string;
    private translate: TranslateService
    constructor(
        @Inject(Injector) private injector: Injector
    ) {
        this.run = this.injector.get(AnalysisRunService).current;
        this.configService = this.injector.get(ConfigService)
        this.log = this.injector.get(LogService)
        this.messageService = this.injector.get(MessageService)
        this.translate = this.injector.get(TranslateService)
    }

    getReplyTo(){
        return this.replyTo
    }

    async runAnalysis(): Promise<AnalysisResult> {
        return new Promise<AnalysisResult>(resolve => {
            const config: IAnalyzerConfig = this.configService.getAnalyzerConfiguration(ANALYZERS.REPLY_TO);
            let level: RiskLevel = RiskLevel.High;
            let info: string[] = [];
            let weight: number = 0;

            try {
                if (this.run.item != null) {
                    const sender: string = this.run.item.sender.emailAddress;

                    try {
                        this.replyTo = this.messageService.getMessageHeaderValue(HEADERS.REPLY_TO);

                        if (this.replyTo && (this.replyTo.includes("<") && this.replyTo.includes(">"))) {
                            this.replyTo = this.replyTo.slice(this.replyTo.indexOf("<") + 1, this.replyTo.indexOf(">"));
                        }

                        if(!this.replyTo)
                            this.replyTo = sender

                        if (!this.replyTo || StringUtils.compareCaseInsensitive(this.replyTo, sender)) {
                            level = RiskLevel.Low;
                            info.push(this.translate.instant('analyzer.reply_address_matches_the_sender_address'));
                            info.push(this.translate.instant('analyzer.reply_address_matches_the_sender_domain'));
                            // weight = config.scores.noneOrSame

                        } else {
                            const replyDomain: string = MailUtils.parseMultiLevelDomain(this.replyTo);
                            const senderDomain: string = MailUtils.parseMultiLevelDomain(sender);

                            if (StringUtils.compareCaseInsensitive(replyDomain, senderDomain)) {
                                level = RiskLevel.Moderate;
                                info.push(this.translate.instant('analyzer.reply_address_does_not_match_the_sender_address'));
                                info.push(this.translate.instant('analyzer.reply_address_matches_the_sender_domain'));

                            } else {
                                level = RiskLevel.High;
                                info.push(this.translate.instant('analyzer.reply_address_does_not_match_the_sender_address'));
                                info.push(this.translate.instant('analyzer.reply_address_matches_the_sender_domain'));
                            }
                        }
                    } catch (e) {
                        level = RiskLevel.Unknown;
                        info.push(this.translate.instant('analyzer.no_internet_headers'));

                        this.log.logException(
                            new Error(`${this.translate.instant('analyzer.error_analyzing_reply_to')} - ${JSON.stringify(e)}`));
                    }
                }
            } catch (e) {
                console.error(e);
            }

            resolve(new AnalysisResult(config.displayName, level, weight, config.description!, info));
        });
    }
}
